import React from 'react';
import { MailIcon, ZapIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-canvasAlt" data-id="element-122" data-mp="3ggtxuh7dth4p">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-8" data-id="element-123" data-mp="32nummremu92y">
        <div className="flex flex-col items-center gap-4 text-center" data-id="element-124" data-mp="32pp5m06cfr4e">
          <div data-id="element-125" data-mp="36q9354utwwr2">
            <p className="flex items-center justify-center gap-1.5 font-display text-base font-black uppercase tracking-[0.16em] text-accent" data-id="element-126" data-mp="36pzeplpfmxnh">
              <ZapIcon size={16} data-id="element-127" data-mp="38h5paxxbklh" />
              CM Digital Pro™
            </p>
            <p className="mt-1.5 font-display text-sm font-bold uppercase tracking-wide text-ink" data-id="element-128" data-mp="36d1erw44jko">
              Aprendé. Practicá. Construí. Emprendé.
            </p>
            <p className="mx-auto mt-2 max-w-2xl text-sm text-ink-muted" data-id="element-129" data-mp="3qbvm7atu2f68">
              Recursos digitales para personas que quieren transformar
              conocimiento en acción. Porque aprender Electrónica no debería
              significar pasar meses perdido entre cientos de tutoriales.
            </p>
            <p className="mt-2 font-semibold text-volt" data-id="element-130" data-mp="3l9si93m2mqny">
              Tu próximo proyecto puede empezar hoy.
            </p>
          </div>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 rounded-lg border border-line bg-surface px-4 py-2.5 text-sm font-semibold text-ink transition-colors duration-150 ease-soft hover:border-accent hover:text-accent" data-id="element-131" data-mp="3v7gbfp413q40">
            <MailIcon size={15} data-id="element-132" data-mp="33xge4qruavo" />
            {SUPPORT_EMAIL}
          </a>
        </div>

        <div className="mt-6 border-t border-line pt-4 text-center text-xs leading-relaxed text-ink-subtle" data-id="element-133" data-mp="323053qg36xx">
          <p data-id="element-134" data-mp="ctqrz5qwypzx">© 2026 CM Digital Pro. Todos los derechos reservados.</p>
          <p className="mt-1" data-id="element-135" data-mp="cvtom8mknhdm">
            Prohibida la reproducción, copia o redistribución del material sin
            autorización expresa.
          </p>
          <p className="mt-1" data-id="element-136" data-mp="mspq3ue1z38o">
            Este sitio no forma parte de Facebook ni de Meta Platforms, Inc. y no
            está respaldado, patrocinado ni administrado por dichas compañías.
            Facebook es una marca comercial de Meta Platforms, Inc.
          </p>
        </div>
      </div>
    </footer>;
}